import _ from "lodash";
import moment from "moment";

/**
 * Fitout Period, in calendar days.
 *
 * "Fit Out Term" and "Fitout Period" are ONE number under two names: Yardi
 * states it as `FitOutTerm` and TCP has always shown it as the fitout period.
 * So the STATED TERM WINS (Sim, 21 Sep 2026) — it is the number a person typed
 * or Yardi sent, and every screen that says "Fitout Period" should agree with
 * the "Fit Out Term (Fitout Period)" row on the lease.
 *
 * `fitout_ends_at - handover_at` is the fallback, for a lease nobody stated a
 * term on. It cannot lead: Yardi never populates `fitout_ends_at`, so on an
 * imported lease `moment(null).diff(...)` returns NaN and the UI used to
 * literally print "NaN (Calendar Days)"; and where TCP's own end date HAS been
 * set it can disagree with the term, in which case the term is the fact.
 *
 * Returns `null` when neither source is available, so callers can show
 * "Unknown" rather than a blank or a NaN.
 */
export const fitoutPeriodDays = (lease: any): number | null => {
	const term = _.get(lease, "fitout_term");
	if (!_.isNil(term) && term !== "") {
		const parsed = parseFloat(`${term}`);
		if (_.isFinite(parsed)) return parsed;
	}

	const endsAt = _.get(lease, "fitout_ends_at");
	const handoverAt = _.get(lease, "handover_at");

	if (endsAt && handoverAt) {
		const days = moment(endsAt).diff(moment(handoverAt), "days");
		if (_.isFinite(days)) return days;
	}

	return null;
};

export default fitoutPeriodDays;
